import * as React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperArrow, TestimonialSlide, ThumbnailItem } from './testimonialParts';
export function Testimonials(_a) {
    var items = _a.items;
    var _b = React.useState(0), activeIndex = _b[0], updateIndex = _b[1];
    var breakpoints = {
        0: {
            spaceBetween: 20
        }
    };
    return (React.createElement("div", { className: 'testimonial-container' },
        React.createElement("div", { className: 'testimonial-slideshow' },
            React.createElement(Swiper, { slidesPerView: 1, spaceBetween: 0, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); }, breakpoints: breakpoints, loop: items.length > 1, autoHeight: true, initialSlide: 0 },
                items.map(function (item, index) {
                    return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                        React.createElement(TestimonialSlide, { item: item, activeIndex: activeIndex }));
                }),
                items.length > 1 &&
                    React.createElement("div", { className: 'testimonial-thumbnails element-flex' },
                        React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.length, direction: 'left' }),
                        items.map(function (item, index) {
                            return React.createElement(ThumbnailItem, { key: "slide-thumbnail-no-".concat(index + 1), index: index, activeIndex: activeIndex, updateIndex: updateIndex });
                        }),
                        React.createElement(SwiperArrow, { activeIndex: activeIndex, totalSlides: items.length, direction: 'right' }))))));
}
